export default __webpack_public_path__ + "static/media/app.bdc5d9cc.png";